import { routes } from "@/common/utils/routes";

export enum TABS_URLS {
  home = "/",
  explore = "/explore",
  add = "/create",
  saved = "/saved",
  profile = "/profile",
  categories = "/categories",
  niches = "/niches",
}

export enum TABS_LABELS {
  home = "Home",
  explore = "Explore",
  add = "Upload",
  saved = "Saved",
  profile = "Profile",
  categories = "Categories",
  niches = "Niches",
}

export const getTabStatus = (
  path: string,
  username: string | null,
): { [key: string]: boolean | null | string } => ({
  [TABS_URLS.home]: path === routes.home(),
  [TABS_URLS.explore]: [
    routes.explore(),
    routes.exploreCreators(),
    routes.exploreImages(),
    routes.niches(),
    routes.exploreTop(),
  ].includes(path),
  [TABS_URLS.add]: path === routes.create(),
  [TABS_URLS.saved]: username && (path === routes.userCollections(username) || path.startsWith(`${routes.userCollections(username)}/`)),
  [TABS_URLS.categories]: path.includes(routes.trendingTags()),
  [TABS_URLS.profile]: username && path === routes.user(username),
  [TABS_URLS.niches]: path.includes(routes.niches()),
});
